import { useEffect } from "react";

const TelegramBackButton = ({ isHomePage }) => {
  const tg = window.Telegram.WebApp;

  useEffect(() => {
    const handleBackButtonClick = () => {
      if (isHomePage) {
        tg.close();
      } else {
        if (window.history.length > 1) {
          window.history.back(); 
        } else {
          tg.close(); // Fallback to closing the Mini App if no history exists
        }
      }
    };

    tg.BackButton.show();
    tg.BackButton.onClick(handleBackButtonClick);

    return () => {
      tg.BackButton.hide();
      tg.BackButton.offClick(handleBackButtonClick); 
    };
  }, [isHomePage, tg]);

  return null; 
};

export default TelegramBackButton;
